import $ from 'jquery';
import LazyLoadService from '../_utilities/lazy-module-service';

export default class PlayerStatistics {
  constructor(elm) {
    this.$element = $(elm);
    this.service = new LazyLoadService();
    this.init();
  }

  _updateDataJsonAttributes(plugin, year) {
    $.extend(true, plugin.JSON, {
      Module: {
        Year: year,
        IsLazyLoadCall: true,
      },
    });

    plugin.$target.attr('data-json-module', JSON.stringify(plugin.JSON));
  }

  async init() {
    const that = this;

    const dropdown = this.$element.find('select');

    $(dropdown).on('change', async function () {
      const selectedYear = this.value;
      const plugin = {};
      plugin.$target = that.$element;

      const dataJson = plugin.$target.attr('data-json-module');
      plugin.JSON = JSON.parse(dataJson);

      that._updateDataJsonAttributes(plugin, selectedYear);
      await that.service.initByElement(false, that.$element, true);
    });
  }
}
